import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AppTextService } from '@fi-shared/app-text';
import { TextEditorService } from '@fi-shared/fi-text-editor/text-editor.service';
import {
    OPERATION_OVERLAY_SMALL_CONTENT_DATA,
    OperationOverlaySmallDialogComponent,
} from '@fi-shared/operation-overlay-small/operation-overlay-small-dialog/operation-overlay-small-dialog.component';

export interface ITextEditorInsertEmbedCodeDialogData {
    Url?: string;
    EmbedText?: string;
}

@Component({
    selector: 'fi-text-editor-insert-embed-code-dialog',
    templateUrl: './text-editor-insert-embed-code-dialog.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./text-editor-insert-embed-code-dialog.component.scss'],
    host: {
        class: 'fi-text-editor-insert-embed-code-dialog',
    },
    standalone: false,
})
export class FiTextEditorInsertEmbedCodeDialogComponent {
    embedModel: ITextEditorInsertEmbedCodeDialogData = {
        Url: null,
        EmbedText: null,
    };

    EmbedUrlMessage;

    constructor(
        protected dialogRef: MatDialogRef<OperationOverlaySmallDialogComponent>,
        @Inject(OPERATION_OVERLAY_SMALL_CONTENT_DATA) public params: any,
        private appTextService: AppTextService,
        private textEditorService: TextEditorService,
    ) {
        if (params.model) {
            this.embedModel.Url = params.model.Url;
            this.embedModel.EmbedText = params.model.EmbedText;
        }
    }

    Cancel() {
        this.dialogRef.close();
    }

    Done() {
        this.dialogRef.close(this.embedModel);
    }

    updateModel() {
        if (this.embedModel.Url) {
            const embedTextFromUrl = this.createEmbedFromUrl(this.embedModel.Url);
            if (embedTextFromUrl === false) {
                this.EmbedUrlMessage = this.appTextService.get('text_editor.embed_code_error');
            } else {
                this.embedModel.EmbedText = embedTextFromUrl;
                this.EmbedUrlMessage = this.appTextService.get('text_editor.embed_code_created');
            }
        } else {
            this.EmbedUrlMessage = undefined;
        }
    }

    private createEmbedFromUrl(url: string) {
        const isUrlValid = this.textEditorService.isEmbdedVideoUrlValid(url);
        if (isUrlValid) {
            const embdedUrl = this.textEditorService.getEmbdedVideoUrl(url);
            return `<iframe src="${embdedUrl}" frameborder="0" allowfullscreen></iframe>`;
        }
        return false;
    }
}
